module.exports = __webpack_public_path__ + "img/x1.bc11a2b4.jpg";